var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-radio-group',{staticClass:"radio-group-buttons",style:({
    '--radio-button-height': _vm.height,
    '--radio-button-border-radius': _vm.borderRadius,
    '--radio-button-min-width': _vm.minWidth,
    '--radio-button-min-font-size': _vm.fontSize,
  }),attrs:{"direction":"horizontal"},on:{"change":_vm.valueChange},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }